import tippy from 'tippy.js';

export const initTooltip = (remainingItem, groupId, Labels) => {
    const tooltipSelector = `#product-tiles__tooltip--${groupId}`;

    const tooltip = `tooltip_${groupId}`;
    window[tooltip] = tippy(tooltipSelector, {
        content: remainingItem <= 1 ? Labels.SelectCategoryTooltip1Item.replace('[0]', remainingItem) : Labels.SelectCategoryTooltip.replace('[0]', remainingItem),
        theme: 'granite',
        arrow: true,
        animation: 'fade',
        placement: 'top',
        allowHTML: true,
        role: 'tooltip',
        popperOptions: {
            placement: 'bottom-start',
            strategy: 'fixed'
        }
    });
};

export const updateTooltip = (stepRemaining, groupId, Labels) => {
    if(!groupId) {
        return;
    }

    const [tooltipInstance] = window[`tooltip_${groupId}`];
    if(!tooltipInstance) {
        return;
    }

    let tooltipText = stepRemaining <= 1 ? Labels.SelectCategoryTooltip1Item.replace('[0]', stepRemaining) : Labels.SelectCategoryTooltip.replace('[0]', stepRemaining);
    const content = tooltipText;

    tooltipInstance.setContent(content);
};
